export default __webpack_public_path__ + "static/implied-motion-dark-3c74a9d96a54efd2ec639ee971328a6f.mp4";